<template>
  <div>
    <Header/>
    <div class="font-body bg-brand-lime pt-10 brand-green-section">
      <Nav/>
      <h2 class="font-heading text-brand-blue text-4xl container mx-auto max-w-6xl "><slot name="title"/></h2>
    </div>
    <div class="container mx-auto max-w-6xl font-body bg- pt-10 white-section bg-white rounded-lg p-5 shadow-lg pb-10">
      <slot/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/shared/Header.vue'
import Nav from '@/components/shared/Nav.vue'

export default {
  name: 'app',
  components: {
    Header,
    Nav
  }
}
</script>

<style lang="scss">
.brand-green-section{
  padding-bottom: 120px;
}
.white-section{
  margin-top:-120px;
}
</style>
